module.exports = __webpack_public_path__ + "static/media/blog-arc-net-announce-icb@2x.3cc083ef.jpg";